import React from "react";
import { Select } from "@foris/avocado-suite";
import UsableLabel from "@common/components/Autocomplete/usabe-label";
import useInstructorSearch, { InstructorOption } from "../../hooks/useInstructorSearch";

interface InstructorSelectProps {
  label?: string;
  placeholder?: string;
  value: InstructorOption | null;
  courseId?: string;
  shouldFilter?: boolean;
  disabled?: boolean;
  isClearable?: boolean;
  menuPlacement?: "top" | "bottom" | "auto";
  onChange: (option: InstructorOption | null) => void;
}

const getFormattedLabel = (option: unknown) => {
  const data = option as InstructorOption;
  return <UsableLabel label={`${data.code} - ${data.name}`} isUsable={data?.usable} />;
};

const InstructorSelect = ({
  label,
  placeholder,
  value,
  courseId,
  shouldFilter = false,
  disabled = false,
  isClearable = false,
  menuPlacement = "bottom",
  onChange,
}: InstructorSelectProps) => {
  const { options, loading, onSearch } = useInstructorSearch({
    courseId,
    shouldFilter,
  });

  return (
    <Select
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      isLoading={loading}
      options={options}
      value={value}
      isClearable={isClearable}
      menuPlacement={menuPlacement}
      isOptionDisabled={option => !!(option as any)?.isDisabled}
      formatOptionLabel={getFormattedLabel}
      onInputChange={val => onSearch(val)}
      onChange={(opt: InstructorOption) => onChange(opt ?? null)}
    />
  );
};

export default InstructorSelect;
